<template>
  <b-card
    tag="b-link"
    @click="gamePlay"
    :img-src="fileUrl(this.getImage(item.imageUrl))"
    :img-alt="item.title"
    img-top
    class="component-product-card card-style d-flex flex-column align-items-stretch game text-dark border-0"
    no-body
  >
    <div class="text-align-start d-flex flex-column justify-content-between py-md-2  px-md-2 p-xxs-1 flex-grow-1">
      <strong v-text="item.title" />
      <small class="d-flex flex-row-reverse text-muted" v-text="item.genre" />
    </div>
    <StarRating
      class="justify-content-center"
      :max-rating="5" 
      :star-size="starSize" 
      :read-only="true"
      :rounded-corners="true" 
      :border-width="starBorderWidth"
      border-color="#FFab40"
      :show-rating="false" 
      inactive-color="#FFFFFF"
      active-color="#FFab40"
      v-model="rate" />
    <Loading v-if="isLoading" />
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import windowSize from '@/mixins/window-size'
import StarRating from 'vue-star-rating'
import Loading from "@/components/Loading";

export default {
  name: 'GameCardBlueTheme',
  mixins: [windowSize],
  components: { StarRating, Loading},
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      rate: Math.floor(Math.random() * 5) + 3  ,
      isImageLoaded: false,
      starBorderWidth: 1.5,
      productUrl: null,
      productRedirectUrl:"",
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl',
      tenantDesignInfo: 'tenantDesign/config'
    }),
    starSize() {
      if (window.innerWidth > 768){
        return 12
      } else {
        return 11
      }
    }
  },
  methods: {
    ...mapActions({
        getProductUrl: 'productCatalog/getProductUrl'
    }),
    getImage (src) {
      var size = this.isMaxWidth768() ? '?w=170' : '?w=280'
      var result = src + size
      return result
    },
    loaded () {
      this.isImageLoaded = true
    },
    gamePlay(){
    this.isLoading = true
     this.getProductUrl(this.item.id).then(result => {
       this.productUrl = result.body.result
       this.isLoading = false
       if (this.tenantDesignInfo.general.hasPromotionFooter) {
        this.productRedirectUrl = '/play/'+this.item.id
         window.localStorage.setItem('productUrl', this.productUrl)
         window.location = this.productRedirectUrl
       } else {
         window.location = this.productUrl
       }
     })
    }
  }
}
</script>
